import { render, staticRenderFns } from "./help-folder.vue?vue&type=template&id=2c996a42&scoped=true&"
import script from "./help-folder.vue?vue&type=script&lang=ts&"
export * from "./help-folder.vue?vue&type=script&lang=ts&"
import style0 from "./help-folder.vue?vue&type=style&index=0&id=2c996a42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c996a42",
  null
  
)

export default component.exports